import { getObjectValue } from '@services/object-extensions';
import cn from 'classnames';
import { Element } from 'react-scroll';
import { LayoutTasti } from '../layout-tasti/layout-tasti';
import { LayoutTesto } from '../layout-testo/layout-testo';
import { LayoutTestoTitolo } from '../layout-testo-titolo/layout-testo-titolo';
import styles from './layout-tasti-destra.module.css';

const LayoutTastiDestra = ({
  translations = {},
  buttons = [],
  darkTheme = false,
  urlImage = '',
  sectionName = '',
  categoryId = ''
}) => {
  const checkStoriesButtons = !(
    buttons?.length > 0 || getObjectValue(translations, 'layoutTasti.card', [])?.length > 0
  );

  const backgroundImage = urlImage
    ? `${darkTheme ? 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), ' : ''}url(${urlImage})`
    : undefined;

  return (
    <Element name={sectionName}>
      <div
        className={cn(styles.hero, `snf-bg-repeat-no-repeat`)}
        style={{
          backgroundImage,
          backgroundColor: darkTheme ? 'black' : 'white'
        }}
      >
        <div className={`container-fluid ${styles.padding} px-3 px-md-5 py-5`} id={categoryId}>
          <div className="row ml-2">
            <div className="col p-0">
              <LayoutTestoTitolo
                translations={getObjectValue(translations, 'layoutTesto', {})}
                darkTheme={darkTheme}
              />
            </div>
          </div>
          <div className="row ml-2">
            <div
              className={cn('col-12 col-md-5 p-0', {
                'snf-text-color-white': darkTheme,
                'col-md-11': checkStoriesButtons
              })}
            >
              <LayoutTesto
                id={sectionName}
                darkTheme={darkTheme}
                translations={getObjectValue(translations, 'layoutTesto', {})}
              />
            </div>

            {!checkStoriesButtons ? (
              <div className="col-12 col-md-5 offset-md-1 p-0">
                <LayoutTasti
                  translations={getObjectValue(translations, 'layoutTasti', {})}
                  buttons={buttons}
                  darkTheme={darkTheme}
                  categoryId={categoryId}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </Element>
  );
};

LayoutTastiDestra.displayName = 'Layout con tasti a destra ';
export { LayoutTastiDestra };
